export default function dateFilter(value) {
  return Math.ceil(value / 60);
}
